import React,{useState} from "react"
import { Link } from "react-router-dom";

import { masonaryData } from "../data/portfolio"

export default function MesonaryPortfolio({grid, row}) {
    let [selectedCategory, setSelectedCategory] = useState(null);

    let matchCategory = (category) => {
        setSelectedCategory(category);
    };
  
    let filteredData = selectedCategory
    ? masonaryData.filter((item) => item.category === selectedCategory)
    : masonaryData;
  return (
    <>
     <div className="row justify-content-center">
            <div className="col-12">
                <div className="filters-group-wrap text-center">
                    <div className="filters-group">
                        <ul className="container-filter mb-0 categories-filter list-unstyled filter-options">
                            <li className={`list-inline-item categories position-relative ${selectedCategory === null ? 'active' : ''}`} onClick={()=>matchCategory(null)}>All</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'branding' ? 'active' : ''}`} onClick={()=>matchCategory('branding')}>Branding</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'designing' ? 'active' : ''}`} onClick={()=>matchCategory('designing')} >Designing</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'photography' ? 'active' : ''}`} onClick={()=>matchCategory('photography')}>Photography</li>
                            <li className={`list-inline-item categories position-relative ${selectedCategory === 'development' ? 'active' : ''}`} onClick={()=>matchCategory('development')}>Development</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div className="row justify-content-center mt-4">
            <div className={grid}>
                <div id="grid" className={row}>
                    {filteredData.map((item,index)=>{
                        return(
                            <div className="mb-3" data-groups='["branding"]' key={index}>
                                <div className="card shadow border-0 portfolio portfolio-masonry portfolio-primary rounded overflow-hidden">
                                    <div className="card-img position-relative">
                                        <img src={item.image} className="img-fluid" alt=""/>
                                        <div className="card-overlay"></div>
                                    </div>
                                    <div className="content bg-white rounded text-center p-3">
                                        <Link to={`/portfolio-detail-two/${item.id}`} className="text-dark h6 mb-0 d-block title">{item.title}</Link>
                                        <small className="text-muted fw-normal mb-0">{item.name}</small>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>  
    </>
  )
}
